export default "__VITE_ASSET__cPBJnaiX__"